<template>
  <button
    v-if="meta.totalCount"
    type="button"
    class="flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md w-full"
    :class="[
      isCurrent
        ? 'bg-gray-200 text-gray-900'
        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
    ]"
    v-on="$listeners"
  >
    <span class="truncate">
      {{ label }}
    </span>

    <span
      v-if="meta.totalSelectedCount"
      class="inline-block py-0.5 px-3 text-xs rounded-full ml-2"
      :class="[isCurrent ? 'bg-gray-50' : 'bg-gray-200 text-gray-600']"
    >
      {{ meta.totalSelectedCount }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    isCurrent: Boolean,
    meta: {
      type: Object,
      default: () => ({
        totalCount: 0,
        totalSelectedCount: 0,
      }),
    },
  },
};
</script>
